module.exports = __webpack_public_path__ + "static/media/total.0146b6e2.png";